import { Box, SearchField, Text } from '@factorialco/deprecated-design-system'
import { times } from 'lodash'

import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'

import { useMessages } from 'modules/finance/hooks/useMessages'

import MessageItem from './MessageItem'
import MessageSkeleton from './MessageSkeleton'

const MessageList = () => {
  const { search, debouncedSearch, onSearch } = useDebouncedSearch()
  const { messages, loading, totalCount } = useMessages(debouncedSearch)

  return (
    <Box minWidth="s400" width="s400">
      <Box
        width="full"
        gap="s8"
        paddingX="s24"
        background="grey200"
        flexDirection="row"
        alignItems="center"
        justifyContent="spaceBetween"
        style={{ paddingTop: '30px', paddingBottom: '30px' }}
      >
        <SearchField
          variant="big"
          search={search}
          onSearch={onSearch}
          placeholder={i18n.t('common.search_by')}
        />
      </Box>
      <Box
        style={{ flex: '1 1 auto' }}
        component="ul"
        overflowY="auto"
        flexGrow
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
      >
        {loading && (
          <>
            {times(5).map((_, index) => (
              <MessageSkeleton key={index} />
            ))}
          </>
        )}
        {!loading &&
          messages &&
          (messages.length == 0 ? (
            <Box height="full" alignItems="center" justifyContent="center">
              <Text.Normal>{i18n.t('ats.messages.messages_table.empty')}</Text.Normal>
            </Box>
          ) : (
            messages.map((message, index) => <MessageItem message={message} key={index} />)
          ))}
      </Box>
      <Box
        flexDirection="row"
        alignItems="center"
        width="full"
        paddingY="s12"
        paddingX="s24"
        background="grey200"
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
      >
        <Text.Normal size="100" color="grey800" weight="medium">
          {i18n.tp('ats.messages.messages_table.showing.items', {
            count: totalCount,
          })}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default MessageList
